import { v2 } from "../../lib/api-v2";
import type { Product, ProductInput, ProductPage } from "./types";

/**
 * Product REST calls, through the shared v2 client (auth, account and request-id
 * headers; failures normalised into ApiV2Error).
 *
 * - `listProducts` / `getProduct`: the read-only view every account gets, once the
 *   admin panel has turned on `products_feature` for it.
 * - `admin*`: TechLadder system admins only; the server refuses anyone else.
 */

const page = (base: string, cursor?: string | null, limit = 50) => {
  const qs = new URLSearchParams({ limit: String(limit) });
  if (cursor) qs.set("cursor", cursor);
  return v2.get<ProductPage>(`${base}?${qs}`);
};

export const listProducts = (cursor?: string | null, limit = 50) => page("/products", cursor, limit);

export const getProduct = (id: string) => v2.get<Product>(`/products/${encodeURIComponent(id)}`);

export const adminListProducts = (cursor?: string | null, limit = 50) =>
  page("/admin/products", cursor, limit);

export const adminCreateProduct = (input: ProductInput) => v2.post<Product>("/admin/products", input);

export const adminUpdateProduct = (id: string, changes: Partial<ProductInput>) =>
  v2.patch<Product>(`/admin/products/${encodeURIComponent(id)}`, changes);

export const adminDeleteProduct = (id: string) =>
  v2.delete<{ id: string; deleted: boolean }>(`/admin/products/${encodeURIComponent(id)}`);
